import { inc, propOr } from 'ramda';
import { isRequiredInput, isRequiredSelect } from '@@viewValidations';
import {
  ControlledGranteeTypeSelect,
  ControlledInput,
  ControlledRadioButton,
  ControlledSelect
} from '@@viewCommonComponents/controlled';
import useGranteeForm from '../hooks/useGranteeForm';
import { DashedTitle } from '@fasstech/middle-design-system';
import { civilityOptions } from '@@viewCommonComponents/forms/options';
import { FormLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import GranteeBirthDate from '@@viewCommonComponents/GranteeBirthdate.jsx';
import { isRequired } from '@@viewHelpers/validations/index.js';

const GranteeForm = ({
  index,
  getMiddleText,
  getMiddleBoolean,
  getMiddleNumber,
  selectedTab,
  regimeObligatoire,
  professionalSituations
}) => {
  const { getFieldsName, granteeIsChild, granteeIsSpouse, form } = useGranteeForm({
    index
  });

  const effectDate = form.watch('offer.effectDate');

  return (
    <FormLayout className={`${selectedTab !== inc(index) ? 'hidden' : ''}`}>
      <DashedTitle>{getMiddleText('BENEFICIAIRE_LABEL_GENERAL_VIEW_SUBTITLE')}</DashedTitle>
      <ControlledGranteeTypeSelect
        form={form}
        name={getFieldsName('type')}
        label={'Type de bénéficiaire'}
        rules={isRequiredInput(getMiddleBoolean('BENEFICIAIRE_TYPE_EST_OBLIGATOIRE'))}
        getMiddleText={getMiddleText}
        ButtonProps={{ disabled: true }}
        disabled
      />
      <GranteeBirthDate
        granteeIsChild={granteeIsChild}
        getFieldsName={getFieldsName}
        form={form}
        getMiddleText={getMiddleText}
        getMiddleBoolean={getMiddleBoolean}
        getMiddleNumber={getMiddleNumber}
        effectDate={effectDate}
        disabled
      />

      <ControlledSelect
        name={getFieldsName('socialSecurities.0.regime')}
        label={'Régime obligatoire'}
        rules={isRequiredSelect(propOr([], 'regimes', regimeObligatoire))}
        form={form}
        options={propOr([], 'regimes', regimeObligatoire)}
        disabled
      />

      <ControlledRadioButton
        options={[
          {
            label: 'Oui',
            value: true
          },
          {
            label: 'Non',
            value: false
          }
        ]}
        label={granteeIsChild ? 'Tarif TNS ?' : 'Votre client est-il un Travailleur Non Salarié ?'}
        name={getFieldsName('isTNS')}
        form={form}
        disabled
      />
      <ControlledSelect
        name={getFieldsName('CSPs.0.categoryLvl1CSPExternalId')}
        label={'Situation professionnelle'}
        form={form}
        options={professionalSituations || []}
        rules={isRequiredSelect(professionalSituations)}
        isDisplayed={granteeIsSpouse}
        disabled
      />
      <ControlledSelect
        name={getFieldsName('civility')}
        label="Civilité"
        form={form}
        options={civilityOptions}
        rules={isRequiredSelect(civilityOptions)}
      />
      <ControlledInput
        name={getFieldsName('lastName')}
        label={'Nom'}
        form={form}
        rules={isRequired}
      />
      <ControlledInput
        name={getFieldsName('firstName')}
        label={'Prénom'}
        form={form}
        rules={isRequired}
      />
    </FormLayout>
  );
};

export default GranteeForm;
